import { render } from "./FAQMeyaButton.vue?vue&type=template&id=bd725528"
import script from "./FAQMeyaButton.vue?vue&type=script&lang=js"
export * from "./FAQMeyaButton.vue?vue&type=script&lang=js"
script.render = render

export default script